import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastMessageService } from '../../../../shared/modules/toast-message/toast-message.service';
import { ModalContent, ModalRef } from '../../../modal-ref';
import { CoolingOffPeriodValues, LimitStatus, LimitType } from '../../../../services/user/data/user-limits.data';
import { FormsErrorHandlerService } from '../../../../services/forms-error-handler.service';
import { UserLimitsService } from '../../../../services/user/user-limits.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { BtnComponent } from '../../../../shared/components/btn/btn.component';
import { FormInputComponent } from '../../../../shared/components/form-controls/form-input/form-input.component';
import { SelectModule } from 'src/app/core/shared/modules/select/select.module';

@Component({
    selector: 'app-edit-session-limit-form',
    templateUrl: './edit-session-limit.component.html',
    styleUrls: ['./edit-session-limit.component.scss'],
    imports: [ReactiveFormsModule, FormInputComponent, SelectModule, BtnComponent, TranslatePipe]
})
export class EditSessionLimitFormComponent implements OnInit, ModalContent {
  private _fb = inject(FormBuilder);
  private _formErrors = inject(FormsErrorHandlerService);
  private _limits = inject(UserLimitsService);
  private _toastMessage = inject(ToastMessageService);


  /**
   * Current modal info
   */
  public info;

  /**
   * Current limit info
   */
  public limit;

  /**
   * Values for select boxes
   */
  public values = {
    [LimitType.COOLINGOFF]: CoolingOffPeriodValues,
  };

  /**
   * Edit limit form
   */
  public form: FormGroup = this._fb.group({
    period: [null, Validators.required]
  });

  /**
   * Errors of period input
   */
  public periodErrors: Array<any> = [];

  public modal: ModalRef;

  get Type() {
    return LimitType;
  }

  get Status() {
    return LimitStatus;
  }

  ngOnInit() {
    this.info = this.modal.options.data.info;
    this.limit = this.modal.options.data.limit;

    setTimeout(() => {
      this.form.get('period').setValue(this.limit.period);
    });
  }

  /**
   * Form submit handler
   */
  submit() {
    this.periodErrors = this._formErrors.applyFormErrors(this.form).period;

    if (this.form.invalid) {
      this.form.get('period').markAsTouched();
      return;
    }

    this._limits.createUpdateLimit({
      type: this.limit.type,
      period: this.form.value.period
    }).pipe(
      tap(() => {
        this._toastMessage.success('t.limit-success-updated');
        this.modal.close(true);
      }),
      catchError(error => {
        this.periodErrors = this._formErrors.applyFormErrors(this.form, error.error).period;
        if (error.error && error.error.errors && error.error.errors.base) {
          const message = error.error.errors.base[Object.keys(error.error.errors.base)[0]];

          this._toastMessage.error(message);
        }
        return of(error);
      })
    ).subscribe();
  }

  /**
   * Cancel button handler
   */
  cancelLimit() {
    this._limits.deleteLimit(this.limit.id).pipe(
      tap(() => {
        this._toastMessage.success('t.limit-canceled-check-confirm');
        this.modal.close(true);
      }),
      catchError(error => {
        this._toastMessage.error('t.something-wrong-contact-support');
        return of(error);
      })
    ).subscribe(() => {
    });
  }

}
